import { render, staticRenderFns } from "./ScrollingBoards.vue?vue&type=template&id=43ca21c6&scoped=true"
import script from "./ScrollingBoards.vue?vue&type=script&lang=js"
export * from "./ScrollingBoards.vue?vue&type=script&lang=js"
import style0 from "./ScrollingBoards.vue?vue&type=style&index=0&id=43ca21c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ca21c6",
  null
  
)

export default component.exports